<template>
  <!-- <basic-container > -->
  <div class="card-container" style="background-color: #fff">
    <div class=".card-row">
      <div class="card card-1">
        <div v-for="(item, index) in docs" :key="index">
          <div class="img1" :class="{ img1Aactive: index == docIndex }" @click="clickDoc(index)">
            <img style="width: 50px; height: auto; margin-right: 10px" src="https://health-planet.oss-cn-shanghai.aliyuncs.com/report/2024-09-07/7a6db4488be9d94eb628ef159db64da777ef.png" />
            <div>
              <div>{{ item.userName }}</div>
              <div>{{ item.title }}</div>
              <div style="color: #76797e">{{ item.hospital }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-row">
      <div class="card card-2">
        <div style="margin-bottom: 1vh" v-for="(item, index) in consult" :key="index">
          <div v-show="item.wxUserId != docId">
            <div>
              <div style="display: flex">
                <div style="padding: 5px 0vw">{{ item.userName }}:</div>
                <div v-if="item.infoType == 1" class="card-3">{{ item.infoDetails }}</div>
                <img v-if="item.infoType == 2" :src="item.infoDetails" class="fixed-width-image" />
                <div v-if="item.infoType == 3" class="pdf-preview-container">
                  <div class="pdf-mini-view" @click="downloadPDF(item)">
                    <iframe v-if="item.infoType == 3" :src="item.infoDetails" width="130px" height="160px" frameborder="0"></iframe>
                    <div class="pdf-overlay">
                      <div class="pdf-icon">📄</div>
                      <div class="download-text">点击下载</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="font-size: 13px; color: rgb(185, 184, 184)">
              {{ item.createTime }}
            </div>
          </div>

          <div v-show="item.wxUserId == docId">
            <div style="display: flex; justify-content: flex-end">
              <div v-if="item.infoType == 1" class="card-4">{{ item.infoDetails }}</div>
              <img v-if="item.infoType == 2" :src="item.infoDetails" class="fixed-width-image" />
              <div v-if="item.infoType == 3" class="pdf-preview-container">
                <div class="pdf-mini-view" @click="downloadPDF(item)">
                  <iframe v-if="item.infoType == 3" :src="item.infoDetails" width="130px" height="160px" frameborder="0"></iframe>
                  <div class="pdf-overlay">
                    <div class="pdf-icon">📄</div>
                    <div class="download-text">点击下载</div>
                  </div>
                </div>
              </div>
              <div style="padding: 5px 0vw">:{{ item.userName }}</div>
            </div>
            <div style="font-size: 13px; color: rgb(185, 184, 184); text-align: right">
              {{ item.createTime }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div style="padding: 0 10px">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="message" :autosize="{ minRows: 5 }" style="font-size: 20px"></el-input>
      </div>
      <div style="display: flex; justify-content: flex-end; padding: 5px 20px 10px 0">
        <el-button @click="sendMsg" type="primary">发 送</el-button>
      </div>
    </div>
  </div>
  <!-- </basic-container> -->
</template>

<script>
import { getConsultDoc, getConsultDetail, sendMsg, close, updateChatDate } from '@/api/health/manage'
export default {
  name: 'ThreeCardLayout',
  data() {
    return {
      wxUserId: '',
      chatId: '',
      consult: [],
      docs: [],
      docIndex: 0,
      docId: '',
      isDoc: false,
      socket: null,
      chatData: [],
      isConnected: false,
      message: '',
      socketBoolean: false
    }
  },
  created() {
    this.chatId = this.$route.query.chatId
    this.wxUserId = this.$route.query.wxUserId

    this.init()
  },
  mounted() {},
  methods: {
    async init() {
      this.socketBoolean = true

      getConsultDoc(this.wxUserId).then(res => {
        this.docs = res.data.docs
        this.chatId = res.data.groupChatId
        if (!this.isDoc && res.data.docs.length !== 0) {
          this.docId = res.data.docs[0].wxUserId
          this.isDoc = true
        }
        this.initSocket()
      })
      getConsultDetail(this.wxUserId).then(res => {
        this.consult = res.data
        this.scrollToGuideDiv()
        updateChatDate(this.wxUserId)
      })
    },

    onload() {
      getConsultDoc(this.wxUserId).then(res => {
        this.docs = res.data.docs
        this.chatId = res.data.groupChatId
        if (!this.isDoc && res.data.docs.length !== 0) {
          this.docId = res.data.docs[0].wxUserId
          this.isDoc = true
        }
      })
      getConsultDetail(this.wxUserId).then(res => {
        this.consult = res.data
        this.scrollToGuideDiv()
        updateChatDate(this.wxUserId)
      })
    },

    initSocket() {
      const domain = 'wss://dbapi.dbzdjk.com/api/imserver/'
      // const domain = 'wss://localhost:8121/api/imserver/'
      // const url = domain + options.wxUserId + options.groupChatId
      // const url = domain + '1891326713570381826' + '1894577969797533698'
      const url = domain + this.docId + this.chatId
      console.log('连接URL:', url)

      try {
        // 关闭之前的连接（如果有）
        if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
          this.socket.close()
        }

        // 创建新的WebSocket连接
        this.socket = new WebSocket(url)

        // 设置事件监听
        this.setupWebSocketEvents()
      } catch (error) {
        console.error('创建WebSocket连接失败:', error)
      }
    },

    setupWebSocketEvents() {
      if (!this.socket) return

      // 连接打开
      this.socket.onopen = () => {
        console.log('WebSocket连接成功建立')
        this.isConnected = true
      }

      // 收到消息
      this.socket.onmessage = event => {
        console.log('收到消息')

        getConsultDetail(this.wxUserId).then(res => {
          console.log(res.data[res.data.length - 1].infoDetails)
          this.consult = res.data
          this.scrollToGuideDiv()
          updateChatDate(this.wxUserId)
        })
      }

      // 连接关闭
      this.socket.onclose = event => {
        console.log('WebSocket连接关闭', event.code, event.reason)
        this.isConnected = false
        if (this.socketBoolean) {
          console.log('重新连接 ...')
          this.init()
        }
      }

      // 连接错误
      this.socket.onerror = error => {
        console.error('WebSocket连接错误:', error)
        this.isConnected = false
      }
    },

    sendMsg() {
      // console.log(this.message)
      if (this.message !== '') {
        const params = {
          wxUserId: this.docId,
          groupChatId: this.chatId,
          message: this.message
        }

        sendMsg(params).then(res => {
          this.onload()
          this.message = ''
          this.scrollToGuideDiv()
          updateChatDate(this.wxUserId)
        })
      }
    },

    scrollToGuideDiv() {
      this.$nextTick(() => {
        const chatContainer = document.querySelector('.card-2')
        if (chatContainer) {
          chatContainer.scrollTo({
            top: chatContainer.scrollHeight,
            behavior: 'smooth'
          })
        } else {
          console.error('未找到聊天容器')
        }
      })
    },

    downloadPDF(item) {
      const link = document.createElement('a')
      link.href = item.infoDetails
      link.download = this.getPDFFileName(item.infoDetails)
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    getPDFFileName(url) {
      if (!url) return 'document.pdf'
      const filename = url.split('/').pop() || 'document.pdf'
      return filename.endsWith('.pdf') ? filename : filename + '.pdf'
    },

    clickDoc(index) {
      this.docIndex = index
      this.docId = this.docs[index].wxUserId
      this.isDoc = true
    },

    // 清理资源
    beforeDestroy() {
      this.closeSocket()
    },

    closeSocket() {
      if (this.socket) {
        this.socket.close(1000, '页面关闭')
        this.socket = null
        this.socketBoolean = true
        close(this.docId + this.chatId).then()
        updateChatDate(this.wxUserId)
        console.log('socket close...')
      }
    }
  }
}
</script>

<style scoped>
.card-container {
  width: 100%;
  max-width: 100vw;
  margin: 0 auto;
  box-sizing: border-box;
  height: calc(100vh - 70px);
  display: grid;
  grid-template-rows: auto 1fr;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 1vw;
}

.card {
  background: #ededed;
  /* border-radius: 8px; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vh 1vw;
  box-sizing: border-box;
}

.card-1 {
  display: flex;
  height: 10vh;
  overflow-y: auto;
  /* text-align: center; */
  font-size: 14px;
  border-bottom: 1px solid #d5d5d5;
  white-space: nowrap;
}

.img1 {
  display: flex;
  padding: 1vh 1vw;
  background-color: #f0f4fe;
  height: 80px;
  margin: 3px 5px;
}

.img1Aactive {
  border: 3px solid #2694ed;
  border-radius: 10px;
}

.card-2 {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 2vh;

  overflow-y: auto;
  height: 70vh;
}

.card-3 {
  border: 0px solid red;
  border-radius: 8px;
  margin-left: 0.5vw;
  padding: 5px 15px;
  background-color: #fff;
}

.card-4 {
  border: 0px solid red;
  border-radius: 8px;
  margin-right: 0.5vw;
  padding: 5px 15px;
  background-color: #95ec69;
}
</style>

<style scoped>
.fixed-width-image {
  width: 600px;
  height: auto;
  max-width: 50%;
  max-height: 300px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.pdf-preview-container {
  margin-left: 10px;
}

.pdf-mini-view {
  position: relative;
  width: 120px;
  height: 160px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.pdf-mini-view:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: #409eff;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  transform: scale(0.3);
  transform-origin: 0 0;
  pointer-events: none;
}

.pdf-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.pdf-mini-view:hover .pdf-overlay {
  opacity: 1;
}

.pdf-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.download-text {
  font-size: 12px;
  color: #409eff;
  font-weight: bold;
}

.msgRegion {
  height: 10vh;
  padding: 5px 15px;
}

</style>
